<ng-container *ngLet="invoice$ | async">
  <div class="h4">
    @if (!isDisabled) {
      <a class="hyperlink" (click)="downloadInvoice(invoiceNumber)" href="javascript:void(0)">Invoice #: {{invoiceNumber}}</a>
    }
    @if (isDisabled) {
      <a class="hyperlink">Invoice #: {{invoiceNumber}}</a>
    }
  </div>
</ng-container>
